import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { pluck, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
const addSupplierAccount = gql`mutation add_supplier_account($supplier_account: supplier_accounts_insert_input!){
  insert_supplier_accounts_one(object: $supplier_account){
    id
  }
}`;

const getSuppliersQuery = gql`query get_suppliers_ids{
  supplier_accounts {
   supplier_id
  }
}`;

const getRemainingDentalSuppliersQuery = gql`query get_remaining_dental_suppliers($exceptIds: [uuid!]){
  dental_suppliers(where:{id: {_nin: $exceptIds}}) {
	  id
    name
    email
    business_name
  }
}`
@Injectable({
  providedIn: 'root'
})
export class AddSupplierAccountService {
/* ------------------------------- Constructor ------------------------------ */
  constructor(private apollo: Apollo) { }

  /* -------------------------- Add Supplier Account -------------------------- */
  addSupplierAccount(supplier_account: any): Promise<any>{
    return this.apollo.use('external').mutate({
      mutation: addSupplierAccount,
      variables: {
        supplier_account
      }
    }).toPromise();
  }

  getRemainingSuppliers(): Observable<any>{
    return this.apollo.use('external').query({
      query: getSuppliersQuery
    }).pipe(
      pluck(
      'data', 'supplier_accounts'),
      switchMap((supplier_accounts:any[])=>{
        return this.apollo.use('external').query({
          query: getRemainingDentalSuppliersQuery,
          variables: {
            exceptIds: supplier_accounts ? supplier_accounts.map(single=>single.supplier_id) : []
          }
        })
      }),
      pluck('data', 'dental_suppliers'));
  }
}
